<form>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between">
    <div fxLayout="column">
      <div
        fxLayout="row"
        fxLayoutAlign="start top">
        <div class="mr-2">
          @if (!!schema) {
            <div class="select is-medium">
              <select
                [id]="filter.uId + '_From'"
                [(ngModel)]="filter.field"
                (change)="fieldChange()"
                [name]="filter.uId + '_From'">
                <option value="">{{ 'MANAGEMENT.DATAFEEDS.EMPTY-FIELD' | translate }}</option>
                @for (field of schemaFields; track field.uId) {
                  <option [ngValue]="field?.systemName">
                    {{ field.displayName }}
                  </option>
                }
              </select>
            </div>
          }
          @if (!!!schema) {
            <div>
              <input
                #genericFilter
                (keydown.enter)="genericFilter.blur()"
                (focus)="onFocus(generic, genericFilter)"
                class="input is-medium"
                type="text"
                placeholder="{{ 'FILTERS.FIELD' | translate }}"
                [id]="filter.uId + '_Field'"
                [name]="filter.uId + '_Field'"
                [(ngModel)]="filter.field"
                style="min-width: 150px" />
            </div>
          }
        </div>
        <div class="mr-2">
          <div class="select is-medium">
            <select
              [id]="filter.uId + '_Op'"
              [name]="filter.uId + '_Op'"
              [(ngModel)]="filter.operator"
              (change)="operatorChange()">
              @for (operator of operators; track operator.value) {
                <option [ngValue]="operator.value">
                  {{ operator.name }}
                </option>
              }
            </select>
          </div>
        </div>
        <div>
          <div>
            <div>
              <!-- Generic Filter -->
              @if (isGenericFilter) {
                <div #generic>
                  <input
                    #genericInput
                    (keydown.enter)="genericInput.blur()"
                    (focus)="onFocus(generic, genericInput)"
                    class="input is-medium"
                    type="text"
                    placeholder="{{ 'FILTERS.VALUE' | translate }}"
                    [id]="filter.uId + '_Val'"
                    [name]="filter.uId + '_Val'"
                    [(ngModel)]="filter.value"
                    style="min-width: 150px" />
                  @if (showSelection && lookupTargetSchemaFields?.length > 0) {
                    <div
                      fxLayout="row"
                      class="select-field-popup mt-1">
                      <button
                        (click)="selectDsField()"
                        class="button is-ghost is-small">
                        <i class="icon icon-token_merge-tag"></i>
                        <span>
                          {{ 'OPERATIONS.DATA-FROM-FIELD' | translate }}
                        </span>
                      </button>
                    </div>
                  }
                </div>
              }
              <!-- Workflow Filter -->
              @if (isWorkflowFilter) {
                <topo-color-item-select
                  [isMedium]="true"
                  [selectedUId]="filter.value"
                  [label]="getWorkflowStepStatusName(filter)"
                  [colorCode]="getWorkflowStepStatusColorCode(filter)"
                  itemColorCode="statusHtmlColorCode"
                  itemLabel="statusName"
                  [items]="workflow?.workflowSteps"
                  (itemSelected)="workflowStepSelected(filter, $event)"
                  placeholderLabel="{{ 'MANAGEMENT.DATAFEEDS.SELECT-VALUE' | translate }}"
                  [isFilter]="true"></topo-color-item-select>
              }

              <!-- Date/Time Filter -->
              @if (isDateTimeFilter) {
                <div
                  #dateTime
                  fxLayout="row">
                  <div>
                    <input
                      #dateTimeInput
                      (keydown.enter)="dateTimeInput.blur()"
                      (focus)="onFocus(dateTime, dateTimeInput)"
                      class="input is-medium"
                      type="text"
                      placeholder="{{ 'FILTERS.VALUE' | translate }}"
                      [id]="filter.uId + '_Val'"
                      [name]="filter.uId + '_Val'"
                      [(ngModel)]="filter.value"
                      style="min-width: 75px" />
                    @if (showSelection && lookupTargetSchemaFields?.length > 0) {
                      <div
                        fxLayout="row"
                        class="select-field-popup mt-1">
                        <button
                          (click)="selectDsField()"
                          class="button is-ghost is-small">
                          <i class="icon icon-token_merge-tag"></i>
                          <span>
                            {{ 'OPERATIONS.DATA-FROM-FIELD' | translate }}
                          </span>
                        </button>
                      </div>
                    }
                  </div>
                  @if (
                    filter.operator === RuleOperator.DateIsWithinLast ||
                    filter.operator === RuleOperator.DateIsNotWithinLast ||
                    filter.operator === RuleOperator.DateIsWithinNext ||
                    filter.operator === RuleOperator.DateIsNotWithinNext
                  ) {
                    <div class="select is-medium">
                      <select
                        class="ml-2"
                        [(ngModel)]="filter.options"
                        [name]="filter.uId + '_Options'">
                        <option [ngValue]="DateFilterOptions.Hours">{{ 'FILTERS.FILTER-OPTIONS-1' | translate }}</option>
                        <option [ngValue]="DateFilterOptions.Days">{{ 'FILTERS.FILTER-OPTIONS-2' | translate }}</option>
                        <option [ngValue]="DateFilterOptions.Weeks">{{ 'FILTERS.FILTER-OPTIONS-3' | translate }}</option>
                        <option [ngValue]="DateFilterOptions.Months">{{ 'FILTERS.FILTER-OPTIONS-4' | translate }}</option>
                        <option [ngValue]="DateFilterOptions.Years">{{ 'FILTERS.FILTER-OPTIONS-5' | translate }}</option>
                      </select>
                    </div>
                  }
                </div>
              }

              <!-- Boolean Filter -->
              @if (isBooleanFilter) {
                <div fxLayout="row">
                  <div class="select is-medium">
                    <select
                      class="ml-2"
                      [(ngModel)]="filter.value"
                      [name]="filter.uId + '_Val'">
                      <option [ngValue]="'true'">{{ 'FILTERS.TRUE' | translate }}</option>
                      <option [ngValue]="'false'">{{ 'FILTERS.FALSE' | translate }}</option>
                    </select>
                  </div>
                </div>
              }

              <!-- Distance Filter -->
              @if (isDistanceFilter) {
                <div #distance>
                  <input
                    #distanceInput
                    (keydown.enter)="distanceInput.blur()"
                    (focus)="onFocus(distance, distanceInput)"
                    [(ngModel)]="filter.displayValue"
                    class="input is-medium"
                    type="text"
                    placeholder="{{ 'FILTERS.VALUE' | translate }}"
                    [id]="filter.uId + '_Val'"
                    [name]="filter.uId + '_Val'"
                    style="min-width: 150px"
                    (ngModelChange)="updateDistanceValue($event, filter)" />
                  @if (showSelection && lookupTargetSchemaFields?.length > 0) {
                    <div
                      fxLayout="row"
                      class="select-field-popup mt-1">
                      <button
                        (click)="selectDsField()"
                        class="button is-ghost is-small">
                        <i class="icon icon-token_merge-tag"></i>
                        <span>
                          {{ 'OPERATIONS.DATA-FROM-FIELD' | translate }}
                        </span>
                      </button>
                    </div>
                  }
                </div>
              }

              <!-- Picklist Filter -->
              @if (isPicklistFilter) {
                <div
                  class="select is-medium"
                  style="max-width: 150px">
                  <select
                    [(ngModel)]="filter.value"
                    type="text"
                    placeholder="{{ 'FILTERS.VALUE' | translate }}"
                    [id]="filter.uId + '_Val'"
                    [name]="filter.uId + '_Val'"
                    style="min-width: 150px">
                    @for (picklistItem of picklistValues[filter?.field]; track picklistItem.uId) {
                      <option [ngValue]="picklistItem.uId">
                        {{ picklistItem.value }}
                      </option>
                    }
                  </select>
                </div>
              }

              <!-- Duration Filter -->
              @if (isDurationFilter) {
                <div>
                  <topo-duration-select
                    [value]="filter.value"
                    (valueChanged)="durationValueChanged(filter, $event)"></topo-duration-select>
                </div>
              }

              <!-- Enumeration Filter -->
              @if (isEnumFilter) {
                <div
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <div
                    class="select is-medium"
                    style="max-width: 150px">
                    <select
                      [(ngModel)]="selectedEnumerationValue[filter?.field]"
                      type="text"
                      placeholder="{{ 'FILTERS.VALUE' | translate }}"
                      [id]="filter.uId + '_Val'"
                      [name]="filter.uId + '_Val'"
                      style="min-width: 150px">
                      @for (enumerationItem of enumerationValues[filter?.field]; track enumerationItem.value) {
                        <option [ngValue]="enumerationItem.value">
                          {{ enumerationItem.name }}
                        </option>
                      }
                    </select>
                  </div>
                  <button
                    class="button is-small is-secondary ml-2"
                    (click)="addEnumInFilterClick()">
                    {{ 'FILTERS.ADD' | translate }}
                  </button>
                </div>
              }

              <!-- BU Filter -->
              @if (isBusinessUnitsFilter && hasBusinessUnits) {
                <div
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <div
                    class="business-units"
                    style="max-width: 150px">
                    <topo-business-unit-select
                      [multiSelectionMode]="false"
                      [selectedUIds]="selectedBusinessUnitValue[filter?.field]"
                      [businessUnits]="businessUnitValues[filter?.field]"
                      [flowMode]="true"
                      location="right"
                      (selectedChanged)="onBusinessUnitsSelectionChanged(filter?.field, $event)"></topo-business-unit-select>
                  </div>
                  <button
                    class="button is-small is-secondary ml-2"
                    (click)="addBusinessUnitFilterClick()">
                    {{ 'FILTERS.ADD' | translate }}
                  </button>
                </div>
              }

              <!-- In Filter -->
              @if (isInFilter) {
                <div class="in-filter-container">
                  <div class="in-filter-input">
                    <input
                      #inFilterInput
                      (keydown.enter)="inFilterInput.blur()"
                      class="input is-medium"
                      type="text"
                      placeholder="{{ 'FILTERS.ADD-VALUE' | translate }}"
                      [id]="filter.uId + '_Val'"
                      [name]="filter.uId + '_Val'"
                      [(ngModel)]="inFilterText"
                      style="min-width: 150px" />
                    <button
                      class="button is-small is-secondary ml-2"
                      (click)="addInFilterClick()">
                      {{ 'FILTERS.ADD' | translate }}
                    </button>
                  </div>
                </div>
              }

              <!-- Geofence Filter -->
              @if (isGeofenceFilter) {
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="select is-medium">
                    <select
                      id="geofenceDataset"
                      name="geofenceDataset"
                      [(ngModel)]="geofenceDatasetUId"
                      (ngModelChange)="geofenceDatasetOnChange($event)">
                      @for (ds of geofenceDatasets; track ds.uId) {
                        <option [ngValue]="ds.uId">
                          {{ ds.name }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="ml-2 select is-medium">
                    <select
                      id="geofenceDocuments"
                      name="geofenceDocuments"
                      (ngModelChange)="geofenceDocumentOnChange($event)"
                      [(ngModel)]="geofenceDocumentUId">
                      @for (doc of geofenceDocuments; track doc.uid) {
                        <option [ngValue]="doc.uid">
                          {{ doc.name }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              }

              <!-- Proximity Filter -->
              @if (isProximityFilter) {
                <button
                  class="button is-medium is-secondary"
                  fxLayout="row"
                  fxLayoutAlign="center center"
                  (click)="openProximitySettings()">
                  <span>{{ proximitySettingsDisplay }}</span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
      @if (filter.operator === RuleOperator.In || filter.operator === RuleOperator.NotIn) {
        <div class="in-filter-item-container">
          @for (filterItem of inFilterItems; track filterItem.id) {
            <div class="in-filter-item">
              <div>{{ filterItem.name | formatLongText: 15 }}</div>
              <div
                type="button"
                (click)="removeInFilterClick(filterItem.id)"
                class="in-filter-remove-button">
                <i class="icon icon-close-X"></i>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div>
      <button
        type="button"
        (click)="deleteFilterClick()"
        class="button is-ghost is-large">
        <i class="icon icon-remove_outline"></i>
      </button>
    </div>
  </div>
</form>
<topo-field-select-modal
  [showFieldSelect]="showSelectionModal"
  [lookupTargetSchemaFields]="lookupTargetSchemaFields"
  [schema]="schemaFields"
  (selectedFieldResponse)="selectedFieldResponse($event)"
  (fieldResponse)="onConfirmField($event)"></topo-field-select-modal>

@if (showProximitySettings) {
  <topo-proximity-filter-settings
    [isActive]="true"
    [settings]="proximitySettings"
    [useForDatamart]="useForDatamart"
    (changed)="proximitySettingsChanged($event)"
    (cancel)="closeProximitySettings()" />
}
